import { render, staticRenderFns } from "./vcSelectExtensionsFile.vue?vue&type=template&id=03c1f1f6&"
import script from "./vcSelectExtensionsFile.vue?vue&type=script&lang=js&"
export * from "./vcSelectExtensionsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports